import type { IconProps } from "./icon-types";

/**
 * 눈 가림(eye off). 숨김/비공개, 비밀번호 가리기 토글 등에서 [[EyeIcon]]과 세트로 사용.
 *
 * [[EyeIcon]](VscEye 모양: 상단 아치 + 눈동자 링)에 사선을 얹어 "가림"을 표현하되,
 * 다른 c6 아이콘(MoonIcon 등)처럼 매끈한 균일 선으로 보이도록 fill이 아닌 stroke로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 24 그리드 / stroke 기반. 눈동자는 사선에 가려지는 쪽(우상단) 호를 빼고 좌하단 호만 그려
 * 사선이 눈동자를 자른 것처럼 보이게 한다.
 */
export const EyeOffIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M4 13A8 7.5 0 0 1 20 13" />
    <path d="M14.56 14.56A3 3 0 1 1 10.44 10.44" />
    <path d="M4 4 20 20" />
  </svg>
);
